import {Storage} from '@stubhub/legacy-cache';
import {CookiesClient} from '@stubhub/react-cookies';
import {logger} from '@stubhub/react-store-provider';
import {post} from '@stubhub/rest-method';

const COOKIE_USER_AUTH = 'session_uAuthenticated';
const COOKIE_USER_LOGIN_TYPE = 'session_login_type';
const GUEST_ROUTE_WHITELIST = ['/my/guest/orderlookup', '/purchase/'];

const COOKIES_CLIENT = new CookiesClient();
const __CLIENT__ = typeof window !== 'undefined';
const w = __CLIENT__ && window && window.location;

const SESSION_PARAMS = {
  host: process.env.REACT_APP_API_HOST,
  path: '/iam/',
};

const closeSession = ({hostname, domain: domainValue}) => {
  // Strip www from the hostname to provide cookie clearing *.stubhub.com or any other host name with wildcarded cookies
  const domain = (hostname && hostname.replace(/^(www\.*\.)/, '.')) || domainValue;

  COOKIES_CLIENT.remove('session_uAuthenticated', {domain, path: '/'});
  COOKIES_CLIENT.remove('session_proxyLogin', {domain, path: '/'});
  COOKIES_CLIENT.remove('session_sessionId', {domain, path: '/'});
  COOKIES_CLIENT.remove('session_contactGUID', {domain, path: '/'});
  COOKIES_CLIENT.remove('session_loginStatus', {domain, path: '/'});
  COOKIES_CLIENT.remove('session_CSRFtoken', {domain, path: '/'});
  COOKIES_CLIENT.remove('session_login_type', {domain, path: '/'});
  COOKIES_CLIENT.remove('session_userGUID', {domain, path: '/'});
  COOKIES_CLIENT.remove('STUB_SESS', {domain, path: '/'});
  COOKIES_CLIENT.remove('track_session_userGUID', {domain, path: '/'});
  COOKIES_CLIENT.remove('SH_TMREFID', {domain, path: '/'});

  Storage.setItem('SH_SMREFID', null, 'local');
  Storage.setItem('track_session_userGUID', null, 'local');
  Storage.setItem('session_sessionId', null, 'local');
  Storage.setItem('session_contactGUID', null, 'local');
  Storage.setItem('session_userGUID', null, 'local');
};

const SessionHelper = {
  loginStatus: () => {
    return COOKIES_CLIENT.get(COOKIE_USER_AUTH) || false;
  },

  loginType: () => {
    return COOKIES_CLIENT.get(COOKIE_USER_LOGIN_TYPE);
  },

  logout: (...args) => {
    return post({
      ...SESSION_PARAMS,
      ...{
        path: '/iam/logout',
      },
      logger,
    }).then(() => {
      closeSession(...args);

      return '';
    });
  },

  validateGuest: ({pathname, hostname}) => {
    let logout = true;
    const path = pathname || w.pathname;
    const host = hostname || w.hostname;

    GUEST_ROUTE_WHITELIST.forEach((route) => {
      if (path.indexOf(route) >= 0 && path !== '/') {
        logout = false;

        return false;
      }
    });

    if (logout) {
      SessionHelper.logout({hostname: host});
    }

    return !logout;
  },
};

export default SessionHelper;
